import { Col, Form, Row, RowProps } from 'antd';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import { darken } from 'polished';
import styled from 'styled-components';
import { breakAt, BreakpointSizes } from 'styles/Breakpoints';

export const Container = styled(Form).attrs({
  className: 'Container',
})`
  background: #fff;
  position: relative;

  .ant-spin-lg .ant-spin-dot {
    font-size: 56px;
  }

  .ant-spin-lg .ant-spin-dot i {
    width: 24px;
    height: 24px;
  }

  .ant-spin-dot-item {
    background: white;
  }
`;

export const Content = styled(Row).attrs({
  className: 'Content',
})`
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0px !important;

  ${breakAt(BreakpointSizes.md)} {
    justify-content: space-between;
    align-items: flex-start;
  }
`;

export const ProductCardComponentImage = styled(Row)`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;

  > div {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }
  span {
    white-space: nowrap;
  }
`;

export const ProductCardComponentDetails = styled(Col)`
  width: 100%;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    border-left: 1px solid #d9d9d9;
  }

  .header {
    align-items: center;
    justify-content: flex-start;
    padding: 8px 24px 0px 24px;

    @media (min-width: ${BREAKPOINTS.phone}) {
      padding: 8px 16px;
    }

    @media (min-width: ${BREAKPOINTS.tabletMini}) {
      padding: 8px 24px 0px 24px;
    }

    .badge-component {
      width: auto;
      border-radius: 2px;
      padding: 2px 4px 1px 4px;
    }

    > .badge {
      text-transform: uppercase;
      white-space: nowrap;

      > span {
        display: flex;
        justify-content: flex-start;
        > div {
          margin-left: 0;
        }
      }
    }

    > .tag {
      display: flex;
      justify-content: center;
    }

    > .share {
      align-self: flex-end;
      margin-left: auto;
    }
  }

  .row-details {
    padding: 0px 16px 16px 16px;

    @media (min-width: ${BREAKPOINTS.tabletMini}) {
      padding: 16px 24px 16px 24px;
    }
  }

  .col-details-color {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-height: 200px;

    p {
      font-weight: 400;
      font-size: 13px;
      line-height: 13px;
      color: #353839;

      span {
        font-weight: 500;
        font-size: 15px;
        line-height: 15px;
      }
    }
  }

  .col-information {
    display: flex;
    flex-direction: column;
    flex: auto;
    gap: 12px;
    padding: 0px 16px;

    @media (min-width: ${BREAKPOINTS.tabletMini}) {
      padding: 0px 24px 8px;
    }
  }
`;

export const OfferInformation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${BREAKPOINTS.phone}) {
    padding: 16px 16px 0px 16px;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding: 16px 32px 0px 32px;
  }
`;

export const OfferInformationTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .anticon {
    align-self: start;
  }

  @media (min-width: ${BREAKPOINTS.phone}) {
    gap: 4px;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    gap: 16px;
  }
`;

export const BadgeContainer = styled.div`
  text-transform: uppercase;

  .badge-component {
    width: auto;
    border-radius: 2px;
    padding: 2px 4px 1px 4px;
  }
`;

export const AuctionContainer = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  display: flex;

  @media (min-width: ${BREAKPOINTS.phone}) {
    flex-direction: column;
    gap: 1px;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: row;
    gap: 4px;
  }
`;

export const AuctionValidity = styled.div`
  color: #8c8c8c;
`;

export const AuctionDateContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const AuctionText = styled.div`
  color: black;
`;

export const AuctionDate = styled.div`
  color: #389e0d;
  font-weight: 700;
`;

export const OfferInformationButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const ProductCardComponentActions = styled(Col)`
  display: flex;
  padding: 0 16px !important;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding: 0 24px !important;
  }

  ${breakAt(BreakpointSizes.md)} {
    padding: 8px 24px 16px 24px !important;
  }

  .line-actions {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: end;
    gap: 16px;
    padding: 0px !important;

    .sale-type-text {
      font-size: 0.875rem;
      font-weight: 700;
    }

    .value-product {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  }

  .line-actions-quantity {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-left: 2px;
    gap: 4px;
    margin-top: 4px;
    font-weight: 400;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: 0%;

    .button-composition {
      align-self: center;
      /* width: 70%; */
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  .line-actions-input {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;

    label {
      font-size: 9px;
    }

    span {
      font-size: 11px;
    }

    > span {
      padding-top: 8px;
      min-width: 98px;
    }

    .ant-row {
      margin-bottom: 0;
    }
  }

  @media (max-width: 992px) {
    .line-actions {
      justify-content: center;
    }
  }
`;

export const ButtonTooltipWrapper = styled.span<{ isDisabled?: boolean }>`
  display: inline-flex;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'auto')};

  > button {
    ${({ isDisabled }) => (isDisabled ? 'pointer-events: none;' : '')}
  }
`;

export const ButtonsContainer = styled(Col)`
  display: flex;
  padding: 16px !important;
  gap: 8px;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding: 16px 24px !important;
  }

  @media (min-width: ${BREAKPOINTS.phone}) {
    flex-direction: column;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: row;
  }

  ${breakAt(BreakpointSizes.md)} {
    padding: 8px 24px 16px 24px !important;
  }

  button {
    cursor: pointer;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    font-size: 14px;
    padding: 8px;
  }

  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .button-cart {
    background: #fff;
    border: 1px solid #f78e1e;
    color: #f78e1e;

    @media (min-width: ${BREAKPOINTS.phone}) {
      width: 100%;
    }

    @media (min-width: ${BREAKPOINTS.tabletMini}) {
      width: 180px;
    }
  }

  .buy-now {
    border: 0;
    color: #fff;
    background: #f78e1e;

    @media (min-width: ${BREAKPOINTS.phone}) {
      width: 100%;
    }

    @media (min-width: ${BREAKPOINTS.tabletMini}) {
      width: 140px;
    }

    &:hover,
    &:active {
      color: #fff;
      background: ${() => darken(0.1, '#f78e1e')};
    }
  }

  .icon {
    font-size: 18px;
  }
`;

export const ComponentInfoNew = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -11px;
  right: -8px;
  background-color: #353839;
  color: #fff;
  border-radius: 16px;
  height: 22px;
  width: 50px;
`;

export const ComponentInfoDirected = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 4px;
  z-index: 99;
  padding: 2px;
  line-height: 18px;
  text-align: center;
  background-color: #52c41a;
  color: #fff;
  border-radius: 4px;
  padding: 0 8px;
  width: 180px;

  span.valeu {
    font-weight: 500;
    font-size: 14px;
  }
`;

export const ComponentInfoVoucher = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 4px;
  z-index: 99;
  padding: 2px;
  line-height: 18px;
  text-align: center;
  background-color: #f78e1e;
  color: #fff;
  border-radius: 4px;
  padding: 0 8px;

  span.valeu {
    font-weight: 500;
    font-size: 14px;
  }
`;

export const InformationVoucher = styled.p`
  margin-bottom: 0;
  font-size: 11px;
  color: #f78e1e !important;
  padding: 0px 0px 16px 0px;
`;

export const InformationProduct = styled(Row)<RowProps>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  height: 14px;

  .anticon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .group-information {
    display: flex;
    gap: 8px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    .ant-select-arrow {
      width: 16px !important;
      height: 16px !important;

      svg {
        color: #f78e1e !important;
        font-size: 1rem;
        border: 1px solid #f78e1e;
        padding: 1px 2px;
      }
    }

    .ant-select .ant-select-selector {
      z-index: 2;
      padding: 0 10px 0 0px !important;
    }

    .title-information {
      margin: 0;
      padding: 0;
      font-weight: 400;
      font-size: 13px;
      line-height: 15px;
      color: #8c8c8c;
    }

    span {
      font-weight: 500;
      font-size: 13px;
      padding: 1px;
      color: #353839;
    }
  }

  .icon-information {
    color: #f78e1e;
  }

  .producer-name {
    gap: 8px;
    font-weight: 700 !important;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #f78e1e !important;

    @media (max-width: ${BREAKPOINTS.tabletMini}) {
      max-width: 200px;
      white-space: nowrap;
    }
  }
`;

export const ProductNameType = styled(Col)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .name-product {
    display: flex;
    flex-direction: column;
    gap: 8px;

    > span {
      justify-content: flex-start;
      font-family: 'Roboto';
      font-style: normal;
      line-height: 100%;
      color: #353839;

      @media (min-width: ${BREAKPOINTS.phone}) {
        font-weight: 400;
        font-size: 1.25rem;
      }

      @media (min-width: ${BREAKPOINTS.tabletMini}) {
        font-weight: 500;
        font-size: 1.875rem;
      }

      > div {
        margin: 0;
      }
    }

    .number-product {
      color: red !;

      font-family: Roboto;
      font-weight: 400;
      font-size: 10px;
      line-height: 100%;
      letter-spacing: 0%;
      color: #8c8c8c;

      span {
        font-family: Roboto;
        font-weight: 400;
        font-size: 10px;
        line-height: 100%;
        letter-spacing: 0%;
        text-transform: uppercase;
        color: #000;
      }
    }

    .gtincode {
    }

    .code-product {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: #8c8c8c;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .number-product {
        margin-right: 16px;
      }
    }
  }
`;

export const ValueProduct = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 16px;

  .value-per-unity {
    margin-top: 4px;
  }

  span {
    font-weight: 400;
    font-size: 11px;
    line-height: 11px;
    color: #8c8c8c;
  }

  span.value {
    font-weight: 700;
    font-size: 21px;
    line-height: 21px;
  }

  span.currency,
  span.value {
    color: #f78e1e;
  }
`;

export const GroupTypeSaleProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const GroupTypeSaleProduct = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 300px;
  align-items: center;

  [type='button'] {
    padding: 0px;
  }

  .divider {
    border-right: 1px solid #d9d9d9;
    margin: 0 2px 0 2px;
    height: 24px;
    align-self: center;
  }

  .ant-radio-wrapper {
    margin: 0px;

    > span {
      padding-right: 0px;
    }
  }
`;

export const Divider = styled.div`
  border-bottom: 1px solid #d9d9d9;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const MinQuantityProduct = styled.div`
  font-weight: 300;
  font-size: 13px;
  line-height: 13px;
  color: #595959;
`;

export const InfoColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const InfoFirstRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
  color: #595959;
`;

export const CompositionLine = styled.div`
  font-size: 12px;
  color: #595959;
  margin-top: 2px;
`;

export const TotalPedidoLine = styled.div`
  font-size: 12px;
  color: #262626;
  font-weight: 600;
  margin-top: 4px;
  padding: 6px 10px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
`;

export const AvailableQuantity = styled.div`
  font-weight: 300;
  font-size: 13px;
  line-height: 13px;
  color: #595959;

  > span {
    margin-left: 4px;
    margin-right: 4px;
  }
`;

export const WarningLabel = styled.p`
  padding: 0 8px;
`;

export const ShareAndClosedContainer = styled(Col)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  display: inline-flex;
  justify-content: flex-end;
  border: 1px solid #d9d9d9;
  padding: 8px;

  > span {
    display: inline-block;
    white-space: nowrap;
    margin-right: 8px;
    font-family: Roboto;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #000000;
  }

  @media (max-width: 600px) {
    > span {
      display: none !important;
    }
  }
`;

export const ShareText = styled.div`
  display: none;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: block;
    font-size: 0.875rem;
    padding-right: 4px;
  }
`;

export const ClosedContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
`;

export const ProductNameEllipsis = styled.span`
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const ConceptNameDetail = styled.span`
  display: -webkit-box;
  font-weight: 700;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const CodeProductContainer = styled.div`
  display: flex;
  color: #8c8c8c;
  font-size: 0.625rem;
  align-items: center;
  gap: 8px;
  color: #8c8c8c;

  span {
    color: #000;
  }

  @media (min-width: ${BREAKPOINTS.phone}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;

export const CodeProductSeparator = styled.div`
  margin: 0 8px;
  color: #bbb;
  font-weight: bold;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const ShippingFee = styled.div`
  font-family: Roboto;
  font-weight: 700;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #f78e1e;
  background-color: #fff9eb;
  padding: 2px 2px 1px 2px;
  width: fit-content;
  margin-top: 4px;
  margin-bottom: 4px;
`;

export const OfferValidityInfo = styled.span`
  color: #8c8c8c !important;
  font-weight: 400;
`;

export const OfferAuctionLabel = styled.span`
  color: #000 !important;
  font-weight: 400;
`;

export const OfferAuctionDate = styled.span`
  color: #389e0d !important;
  font-weight: 700 !important;
`;

export const OfferCalendarIcon = styled.span`
  svg {
    color: #ff9800 !important;
    vertical-align: middle;
    margin-left: 2px;
  }
`;

export const VoucherInfoGreen = styled.p`
  margin: 4px 0 0 0;
  font-size: 10px;
  line-height: 12px;
  color: #389e0d;
  width: 100%;
`;
